"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAutomaticEmailFailureTypeToString = transformAutomaticEmailFailureTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformAutomaticEmailFailureTypeToString(automaticEmailFailureType) {
    switch (automaticEmailFailureType) {
        case legacy_enums_1.AutomaticEmailFailureType.Bounce:
            return "Bounce";
        case legacy_enums_1.AutomaticEmailFailureType.DNS:
            return "DNS issue";
        case legacy_enums_1.AutomaticEmailFailureType.Invalid:
            return "Invalid or non-existing email";
        case legacy_enums_1.AutomaticEmailFailureType.Server:
            return "Mail server issue";
        case legacy_enums_1.AutomaticEmailFailureType.Spam:
            return "Spam";
        case legacy_enums_1.AutomaticEmailFailureType.Timeout:
            return "Mail server timeout";
        case legacy_enums_1.AutomaticEmailFailureType.Unknown:
        default:
            return "Unknown";
    }
}
//# sourceMappingURL=transformAutomaticEmailFailureTypeToString.js.map